import './style.css';
// First import on purpose: installs the global error notifications before any
// other module can fail during evaluation (e.g. scene-builder's top-level await).
import { notifyViewerFailure } from './modules/error-notifications';
import { setDebugOverlayVisibility } from './modules/debug-log';
import { setInfoOverlayVisibility } from './modules/info';
import { getDeviceType, getXRFrameworkToUse } from './modules/helper/device-helper';
import { showVRViewBeforeAR } from './modules/scene-builder';
import { initUI, showARStartButtonAndAddListener, showARUIElements } from './modules/ui-manager';

export { arStartBtn } from './modules/ui-manager';

export const forceIOSImplementationOnAndroid = false;
export let xrFramework: string | null = null;

const debugOverlayVisibility = false;
const infoOverlayVisibility = false;

setDebugOverlayVisibility(debugOverlayVisibility);
setInfoOverlayVisibility(infoOverlayVisibility);

async function init() {
  initUI();
  const device = getDeviceType();

  if (device !== 'desktop') {
    xrFramework = await getXRFrameworkToUse(device);
    switch (xrFramework) {
      case 'webxr': {
        await startWithWebXR();
        break;
      }
      case '8th-wall': {
        await startWith8thWall();
        break;
      }
      case 'zapworks': {
        await startWithZapworks();
        break;
      }
      case 'needle': {
        await startWithNeedle();
        break;
      }
      default:
        break;
    }
  } else {
    const { showVROrbitView } = await import('./modules/vr-orbit-view-integration');
    await showVROrbitView();
  }
}

/** `init` is started from an event handler, so nobody else can catch its rejection. */
async function startViewer() {
  try {
    await init();
  } catch (error) {
    notifyViewerFailure({
      title: 'Die Ansicht konnte nicht gestartet werden',
      error,
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startViewer);
} else {
  startViewer();
}

async function startWithWebXR() {
  const { showVROrbitView } = await import('./modules/vr-orbit-view-integration');
  await showVROrbitView();
  const { startARWithWebXR } = await import('./modules/xr-integrations/webxr-xr-integration');
  showARStartButtonAndAddListener(async () => {
    await startARWithWebXR();
  });
}

async function startWith8thWall() {
  const { startARwith8thwall } = await import('./modules/xr-integrations/8th-wall-xr-integration');
  if (showVRViewBeforeAR) {
    const { showVROrbitView } = await import('./modules/vr-orbit-view-integration');
    await showVROrbitView();
    showARStartButtonAndAddListener(() => {
      startARwith8thwall();
    });
  } else {
    showARUIElements();
    startARwith8thwall();
  }
}

async function startWithZapworks() {
  const { startARwithZapworks } = await import('./modules/xr-integrations/zapworks-xr-integration');
  if (showVRViewBeforeAR) {
    const { showVROrbitView } = await import('./modules/vr-orbit-view-integration');
    await showVROrbitView();
    showARStartButtonAndAddListener(() => {
      startARwithZapworks();
    });
  } else {
    showARUIElements();
    startARwithZapworks();
  }
}

async function startWithNeedle() {
  const { initARwithNeedle } = await import('./modules/xr-integrations/needle-xr-integration');
  initARwithNeedle();
}
